export const MAX_PROVIDER_WAIT_MS = 5 * 60 * 1000;

export function parseRetryAfter(value: string | null, now = Date.now()): number | null {
  if (!value?.trim()) return null;
  const trimmed = value.trim();
  if (/^\d+(\.\d+)?$/.test(trimmed)) {
    const ms = Number(trimmed) * 1000;
    return Number.isFinite(ms) ? ms : null;
  }
  // Do not let Date.parse reinterpret malformed numeric durations as years.
  if (!/[a-z]/i.test(trimmed)) return null;
  const date = Date.parse(trimmed);
  return Number.isFinite(date) ? Math.max(0, date - now) : null;
}

export function retryDelayMs(providerMs: number | null, fallbackMs: number): number {
  if (providerMs !== null && Number.isFinite(providerMs) && providerMs >= 0) {
    return providerMs + Math.random() * Math.min(providerMs * 0.25, 1000);
  }
  return fallbackMs * (0.75 + Math.random() * 0.5);
}

export function waitForRetry(ms: number, signal?: AbortSignal | null): Promise<void> {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) { reject(new Error('Request cancelled')); return; }
    const onAbort = () => { clearTimeout(timer); signal?.removeEventListener('abort', onAbort); reject(new Error('Request cancelled')); };
    const timer = setTimeout(() => { signal?.removeEventListener('abort', onAbort); resolve(); }, ms);
    signal?.addEventListener('abort', onAbort, { once: true });
  });
}
